import api from "../globals/axios";
import { SERVER_BASE_ADDRESS } from "../globals/const";
import {
  PROGRAMS_ENDPOINT,
  PROGRAM_INPUTS_ENDPOINT,
  PROGRAM_INPUT_TASKS_ENDPOINT,
  UPLOAD_PROGRAM_ENDPOINT,
  DOWNLOAD_PROGRAM_TEMPLATE_ENDPOINT,
} from "../globals/endpoints";

export async function createProgram(programName) {
  const response = await api.post(PROGRAMS_ENDPOINT, { name: programName });
  return response.data;
}

export async function getProgram(programId) {
  const response = await api.get(`${PROGRAMS_ENDPOINT}${programId}/`);
  return response.data;
}

export async function getPrograms() {
  const response = await api.get(PROGRAMS_ENDPOINT);
  return response.data;
}

export async function createProgramInput(input) {
  const response = await api.post(`${PROGRAM_INPUTS_ENDPOINT}`, input);
  return response.data;
}

export async function getProgramInputs(programId) {
  const response = await api.get(
    `${PROGRAM_INPUTS_ENDPOINT}?program_id=${programId}`
  );
  return response.data;
}

export async function getProgramInput(programInputId) {
  const response = await api.get(
    `${PROGRAM_INPUTS_ENDPOINT}${programInputId}/`
  );
  return response.data;
}

export async function getProgramInputTasks(programInputId) {
  const response = await api.get(
    `${PROGRAM_INPUT_TASKS_ENDPOINT}?program_input_id=${programInputId}`
  );
  return response.data;
}

export async function createProgramInputTask(task) {
  const response = await api.post(`${PROGRAM_INPUT_TASKS_ENDPOINT}`, task);
  return response.data;
}

export async function uploadProgramInputs(programId, input) {
  const formData = new FormData();
  formData.append("input_file", input.input_file);

  const response = await api.post(
    `${UPLOAD_PROGRAM_ENDPOINT}${programId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
}

export async function downloadProgramTemplate() {
  window.open(`${SERVER_BASE_ADDRESS}${DOWNLOAD_PROGRAM_TEMPLATE_ENDPOINT}`);
}
